export const RouletteMatchId: Record<RouletteEventId, RouletteBoardId> = {
  '23FW-Invite': '23FW-1',
  '23FW-High-Invite': '23FW-1',
  '23FW-High': '23FW-1',
  // '23FW-Univ': '23FW-1',
};
